import '../Login/styled.css'
import './style.css'
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'
import { IoIosWarning } from "react-icons/io";
import { AuthContext } from '../../context/AuthContext';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';

function SemEmpresa() {
    const navigate = useNavigate()
    const { setAuth } = useContext(AuthContext)
    const { setSemEmpresaVinculada } = useContext(ApiContext)
    const { logoLogin, bodyLogin, loginFormBtn } = useContext(StyleContext)

    const sair = () => {
        Cookies.remove("Token")
        Cookies.remove("Key")
        setSemEmpresaVinculada(false)
        setAuth(false);
        navigate('/');
    }

    return (
        <div className="body-login" style={bodyLogin}>
            <div className="container-login">
                <div className="wrap-login">
                    <div className="logo-empresa" style={{ marginBottom: '30px' }}>
                        <img src={`${logoLogin}`} alt="logo" />
                    </div>
                    <div className="sem-empresa-aviso">
                        <IoIosWarning className="sem-empresa-icon" />
                        <p>Nenhuma empresa vinculada a esse usuário. Contate seu administrador.</p>
                    </div>
                    <div className="container-login-form-btn">
                        <button style={loginFormBtn} onClick={() => sair()}>Sair</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SemEmpresa;
